var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 9.25C34.5815 9.25 34.8995 9.1183 35.1339 8.88388C35.3683 8.64946 35.5 8.33152 35.5 8V3C35.5 2.33696 35.2366 1.70107 34.7678 1.23223C34.2989 0.763392 33.663 0.5 33 0.5H3C2.33696 0.5 1.70107 0.763392 1.23223 1.23223C0.763392 1.70107 0.5 2.33696 0.5 3V8C0.5 8.33152 0.631696 8.64946 0.866116 8.88388C1.10054 9.1183 1.41848 9.25 1.75 9.25C2.74456 9.25 3.69839 9.64509 4.40165 10.3483C5.10491 11.0516 5.5 12.0054 5.5 13C5.5 13.9946 5.10491 14.9484 4.40165 15.6516C3.69839 16.3549 2.74456 16.75 1.75 16.75C1.41848 16.75 1.10054 16.8817 0.866116 17.1161C0.631696 17.3505 0.5 17.6685 0.5 18V23C0.5 23.663 0.763392 24.2989 1.23223 24.7678C1.70107 25.2366 2.33696 25.5 3 25.5H33C33.663 25.5 34.2989 25.2366 34.7678 24.7678C35.2366 24.2989 35.5 23.663 35.5 23V18C35.5 17.6685 35.3683 17.3505 35.1339 17.1161C34.8995 16.8817 34.5815 16.75 34.25 16.75C33.2554 16.75 32.3016 16.3549 31.5983 15.6516C30.8951 14.9484 30.5 13.9946 30.5 13C30.5 12.0054 30.8951 11.0516 31.5983 10.3483C32.3016 9.64509 33.2554 9.25 34.25 9.25Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.7a114ea205429a5c87cc0d5af7e3050f.svg";
export { ForwardRef as ReactComponent };